"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9652],{

/***/ 74816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Checkmark_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2888);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var SvgCheckmark = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "m9.218 15.319 9.967-9.966Q19.537 5 20.022 5q.486 0 .838.353.354.352.353.838 0 .484-.353.838L10.042 17.847q-.354.353-.824.353t-.823-.353L3.34 12.791A1.1 1.1 0 0 1 3 11.953a1.2 1.2 0 0 1 .367-.838q.353-.353.838-.353t.838.353z"
        })
    }));
};
var Checkmark_default = SvgCheckmark;



/***/ }),

/***/ 25923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ ButtonLoadingAnimation; },
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_native_web__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53089);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20129);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61274);
/* harmony import */ var _shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65243);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);











var buttonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.button */ .T.button, sharedFrameConfig = {
    name: "Button",
    cursor: "pointer",
    userSelect: "none",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: buttonTokens.borderWidth.default,
    animation: "linear",
    pressStyle: {
        scale: (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_3__/* .getStateTokenValue */ .GJ)(buttonTokens.state.pressedScale)
    },
    variants: {
        variant: function(variant, param) {
            var props = param.props;
            return {
                backgroundColor: props.disabled ? buttonTokens.color.background.state.inactive[variant] : buttonTokens.color.background[variant],
                borderColor: props.disabled ? buttonTokens.color.border.state.inactive[variant] : buttonTokens.color.border[variant],
                hoverStyle: props.disabled ? {} : {
                    backgroundColor: buttonTokens.color.background.state.hover[variant],
                    borderColor: buttonTokens.color.border.state.hover[variant]
                },
                focusVisibleStyle: {
                    outlineStyle: "solid",
                    outlineWidth: buttonTokens.outlineWidth.state.focus.default,
                    outlineOffset: buttonTokens.padding.border.focus,
                    outlineColor: buttonTokens.color.border.state.focused[variant]
                }
            };
        },
        size: function(size) {
            return {
                paddingHorizontal: buttonTokens.padding.leftRight[size],
                paddingVertical: buttonTokens.padding.topBottom[size],
                borderRadius: buttonTokens.cornerRadius[size],
                maxWidth: size in buttonTokens.size.maxWidth ? buttonTokens.size.maxWidth[size].state.default : void 0,
                height: size in buttonTokens.size.height ? buttonTokens.size.height[size] : void 0
            };
        },
        disabled: {
            true: {
                pointerEvents: "none"
            }
        },
        loading: {
            true: {
                pointerEvents: "none"
            }
        }
    }
}, AnchorFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "a",
    accessibilityRole: "link",
    textDecorationLine: "none",
    display: "flex",
    position: "relative"
})), ButtonFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "button",
    accessibilityRole: "button"
})), AnchorOrButtonFrame = (0,_shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__/* .createAnchorOrButtonFrame */ .r)({
    AnchorFrame: AnchorFrame,
    ButtonFrame: ButtonFrame
}), ButtonLoadingContainer = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    variants: {
        variant: function(variant, param) {
            var props = param.props;
            return {
                backgroundColor: "isDisabled" in props && props.isDisabled ? buttonTokens.color.background.state.inactive[variant] : buttonTokens.color.background[variant]
            };
        },
        frameSize: function(size) {
            return {
                borderRadius: buttonTokens.cornerRadius[size],
                gap: buttonTokens.padding.loadingAnimation[size]
            };
        },
        // isDisabled prop is only used to determine backgound color
        isDisabled: {
            true: {}
        }
    }
}), ButtonLoadingAnimation = function(param) {
    var variant = param.variant, size = param.size, isDisabled = param.isDisabled;
    var colorToken = isDisabled ? buttonTokens.color.content.state.inactive[variant] : buttonTokens.color.content[variant], sizeToken = buttonTokens.size.loadingAnimation[size], borderRadiusToken = buttonTokens.cornerRadius.loadingAnimation.default, colorValue = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.getTokens)().color[colorToken].val, sizeValue = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.getTokens)().size[sizeToken].val, borderRadiusValue = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.getTokens)().radius[borderRadiusToken].val, baseStyles = {
        backgroundColor: colorValue,
        width: sizeValue,
        height: sizeValue,
        borderRadius: borderRadiusValue
    }, dotOne = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Value */ .Z.Value(1)).current, dotTwo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Value */ .Z.Value(0)).current, dotThree = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Value */ .Z.Value(0)).current, dotFour = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Value */ .Z.Value(0)).current, duration = 300, delay = 50;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var loop = react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].loop */ .Z.loop(react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].sequence */ .Z.sequence([
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotOne, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotTwo, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotTwo, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotThree, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotThree, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotFour, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].delay */ .Z.delay(delay),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotFour, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotThree, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotThree, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotTwo, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotTwo, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotOne, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].delay */ .Z.delay(delay)
        ]));
        return loop.start(), function() {
            loop.stop();
        };
    }, [
        dotOne,
        dotTwo,
        dotThree,
        dotFour
    ]);
    var opacityMinValue = Number(variant === "secondary" ? buttonTokens.computedValues.opacity.loadingAnimation.inverse : buttonTokens.computedValues.opacity.loadingAnimation.default), interpolation = {
        inputRange: [
            0,
            1
        ],
        outputRange: [
            opacityMinValue,
            1
        ]
    };
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(ButtonLoadingContainer, {
        isDisabled: isDisabled,
        variant: variant,
        frameSize: size,
        testID: "button-loading-container",
        children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].View */ .Z.View, {
                style: [
                    baseStyles,
                    {
                        opacity: dotOne.interpolate(interpolation)
                    }
                ]
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].View */ .Z.View, {
                style: [
                    baseStyles,
                    {
                        opacity: dotTwo.interpolate(interpolation)
                    }
                ]
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].View */ .Z.View, {
                style: [
                    baseStyles,
                    {
                        opacity: dotThree.interpolate(interpolation)
                    }
                ]
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].View */ .Z.View, {
                style: [
                    baseStyles,
                    {
                        opacity: dotFour.interpolate(interpolation)
                    }
                ]
            })
        ]
    });
}, Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var variant = _param.variant, size = _param.size, disabled = _param.disabled, loading = _param.loading, label = _param.label, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
        "variant",
        "size",
        "disabled",
        "loading",
        "label"
    ]);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(AnchorOrButtonFrame, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variant: variant,
        size: size,
        disabled: disabled,
        focusable: !disabled,
        loading: loading,
        "aria-disabled": disabled || loading,
        ref: ref
    }, rest), {
        children: [
            loading && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(ButtonLoadingAnimation, {
                isDisabled: disabled,
                variant: variant,
                size: size
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                tag: "span",
                typography: buttonTokens.typography[size],
                color: disabled ? buttonTokens.color.content.state.inactive[variant] : buttonTokens.color.content[variant],
                numberOfLines: 1,
                children: label
            })
        ]
    }));
});



/***/ }),

/***/ 44468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ SimpleCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20129);
/* harmony import */ var _tamagui_checkbox_headless__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70357);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74816);
/* harmony import */ var _helpers_useObservabilitySafe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1252);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56350);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46523);
/* harmony import */ var _shared_TrackableContainer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45822);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(76614);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49555);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68362);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
















var checkboxTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.radioCheckbox */ .T.radioCheckbox, SimpleCheckbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, label = _param.label, value = _param.value, _defaultChecked = _param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? !1 : _defaultChecked, disabled = _param.disabled, invalid = _param.invalid, id = _param.id, onPress = _param.onPress, name = _param.name, trackImpression = _param.trackImpression, checked = _param.checked, ariaLabel = _param.ariaLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "label",
        "value",
        "defaultChecked",
        "disabled",
        "invalid",
        "id",
        "onPress",
        "name",
        "trackImpression",
        "checked",
        "ariaLabel"
    ]);
    var _$ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useProps)(props), _size = _$ref.size, size = _size === void 0 ? "medium" : _size, trackJourneyEvent = (0,_helpers_useObservabilitySafe__WEBPACK_IMPORTED_MODULE_5__/* .useObservabilitySafe */ .r)().trackJourneyEvent, _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultChecked), internalChecked = _$ref1[0], setInternalChecked = _$ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        checked !== void 0 && setInternalChecked(checked);
    }, [
        checked
    ]);
    var onCheckedChange = function(e) {
        e.stopPropagation(), onPress && onPress(value, !internalChecked), trackJourneyEvent("platform", "checkboxClickEvent", {
            targetName: analyticsName,
            optionName: value
        });
    }, _$ref2 = (0,_tamagui_checkbox_headless__WEBPACK_IMPORTED_MODULE_6__/* .useCheckbox */ .O)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        name: name,
        value: value,
        defaultChecked: defaultChecked,
        disabled: disabled,
        onPress: onCheckedChange
    }, props), [
        internalChecked,
        setInternalChecked
    ], ref), checkboxProps = _$ref2.checkboxProps, checkboxRef = _$ref2.checkboxRef, bubbleInput = _$ref2.bubbleInput, inputId = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useInputId */ .U0)(id), _$ref3 = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useCheckBoxRadioState */ .D)({
        checked: internalChecked,
        disabled: disabled,
        invalid: invalid
    }), rowState = _$ref3.rowState, buttonState = _$ref3.buttonState, handleFocus = _$ref3.handleFocus, handleBlur = _$ref3.handleBlur, _$ref4 = getCheckMarkIconStyle(size, buttonState), checkMarkSize = _$ref4.checkMarkSize, checkMarkColor = _$ref4.checkMarkColor;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_TrackableContainer__WEBPACK_IMPORTED_MODULE_10__/* .TrackableContainer */ .z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        eventName: "checkboxViewEvent",
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(CheckboxRowButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, checkboxProps), {
            "aria-invalid": _tamagui_core__WEBPACK_IMPORTED_MODULE_4__.isWeb ? invalid : void 0,
            "aria-required": _tamagui_core__WEBPACK_IMPORTED_MODULE_4__.isWeb ? props.required : void 0,
            "aria-label": ariaLabel,
            ref: checkboxRef,
            size: size,
            state: rowState,
            onFocus: handleFocus,
            onBlur: handleBlur,
            focusable: !disabled,
            id: inputId,
            children: [
                /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Checkbox, {
                    disabled: disabled,
                    size: size,
                    state: {
                        state: buttonState,
                        checked: internalChecked
                    },
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    focusable: !1,
                    alignSelf: "flex-start",
                    children: [
                        internalChecked === !0 && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            size: checkMarkSize,
                            color: checkMarkColor
                        }),
                        bubbleInput
                    ]
                }),
                label && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                    alignSelf: "center",
                    flex: 1,
                    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                        alignSelf: "flex-start",
                        textAlign: "left",
                        tag: "label",
                        htmlFor: id,
                        cursor: "inherit",
                        typography: checkboxTokens.typography.simpleCheckbox[size],
                        color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(buttonState, checkboxTokens.color.content.valueText.state) ? checkboxTokens.color.content.valueText.state[buttonState] : checkboxTokens.color.content.valueText.default,
                        children: label
                    })
                })
            ]
        }))
    });
}), CheckboxRowButton = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, {
    tag: "button",
    display: "flex",
    flexDirection: "row",
    /**
   * Combined size and state into one variant because there are multiple times we need to use both to determine the style (especially for small/xsmall)
   * Seperating these two variants causes confusion and causes strange overrides
   */ variants: {
        state: function(state) {
            return {
                cursor: state === "inactive" ? "default" : "pointer"
            };
        },
        size: function(size) {
            var updatedSize = size === "xsmall" ? "small" : size;
            return {
                borderColor: "$transparent",
                backgroundColor: "$transparent",
                paddingTop: checkboxTokens.margin.simpleCheckbox.topBottom[updatedSize],
                paddingBottom: checkboxTokens.margin.simpleCheckbox.topBottom[updatedSize],
                gap: checkboxTokens.padding.simpleCheckbox[updatedSize]
            };
        }
    }
}), Checkbox = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.Stack, {
    borderWidth: checkboxTokens.borderWidth.default,
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    alignSelf: "center",
    variants: {
        size: function(size) {
            var widthAndHeight = {
                xsmall: checkboxTokens.size.element.radio.exterior.xsmall,
                small: checkboxTokens.size.element.radio.exterior.small,
                medium: checkboxTokens.size.element.radio.exterior.medium
            };
            return {
                borderRadius: checkboxTokens.cornerRadius.element.checkbox[size === "small" || size === "xsmall" ? "smallXsmall" : size],
                width: widthAndHeight[size],
                height: widthAndHeight[size]
            };
        },
        // eslint-disable-next-line jsdoc/require-jsdoc
        state: function(param) {
            var state = param.state, checked = param.checked;
            return {
                borderColor: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.border.element.checkbox.state) ? checkboxTokens.color.border.element.checkbox.state[state] : checkboxTokens.color.border.element.checkbox.default,
                backgroundColor: (checked || state === "inactive") && (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.background.element.checkboxRadio.state) ? checkboxTokens.color.background.element.checkboxRadio.state[state] : "$transparent"
            };
        }
    }
}), getCheckMarkIconStyle = function(size, state) {
    return {
        checkMarkSize: size === "small" ? 20 : 24,
        checkMarkColor: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.content.element.checkIcon.state) ? checkboxTokens.color.content.element.checkIcon.state[state] : checkboxTokens.color.content.element.checkIcon.default
    };
};



/***/ }),

/***/ 68362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useCheckBoxRadioState; },
/* harmony export */   "q": function() { return /* binding */ getCustomRadioCheckboxRowStyling; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20129);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56350);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49555);



var radioCheckbox = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.radioCheckbox */ .T.radioCheckbox, useCheckBoxRadioState = function(param) {
    var disabled = param.disabled, errorText = param.errorText, invalid = param.invalid, onFocus = param.onFocus, onBlur = param.onBlur, checked = param.checked;
    var ref = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useInputState */ .U1)({
        disabled: disabled,
        errorText: errorText,
        invalid: invalid,
        onFocus: onFocus,
        onBlur: onBlur
    }), state = ref.state, handleFocus = ref.handleFocus, handleBlur = ref.handleBlur, setFocused = ref.setFocused, rowState = state || (checked && checked !== "indeterminate" ? "selected" : void 0);
    return {
        rowState: rowState,
        buttonState: state === "focused" && checked ? "selected" : rowState,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        setFocused: setFocused
    };
}, getCustomRadioCheckboxRowStyling = function(param) {
    var size = param.size, state = param.state;
    var isXSmall = size === "xsmall", disabled = state === "inactive", focused = state === "focused", hoverStyle = disabled ? {} : {
        borderColor: isXSmall ? "$transparent" : radioCheckbox.color.border.row.state.hover,
        backgroundColor: isXSmall ? radioCheckbox.color.background.element.row.state.hover : "$transparent"
    }, focusStyle = focused && !disabled ? {
        borderColor: radioCheckbox.color.border.row.state.focused,
        borderWidth: radioCheckbox.borderWidth.default
    } : {}, cursor = state === "inactive" ? "default" : "pointer", borderColor = isXSmall ? void 0 : (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.border.row.state) ? radioCheckbox.color.border.row.state[state] : radioCheckbox.color.border.row.default;
    return {
        backgroundColor: "$transparent",
        height: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.size.rowHeight) ? radioCheckbox.size.rowHeight[size] : 0,
        paddingRight: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.padding.leftRight) ? radioCheckbox.padding.leftRight[size] : 0,
        paddingLeft: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.padding.leftRight) ? radioCheckbox.padding.leftRight[size] : 0,
        borderRadius: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.cornerRadius.row) ? radioCheckbox.cornerRadius.row[size] : 0,
        borderWidth: radioCheckbox.borderWidth.default,
        // hides the border if it's xsmall
        borderColor: borderColor || "$transparent",
        hoverStyle: hoverStyle,
        focusStyle: focusStyle,
        cursor: cursor
    };
};



/***/ }),

/***/ 49555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ useInputName; },
/* harmony export */   "N7": function() { return /* binding */ useFrameFocus; },
/* harmony export */   "U0": function() { return /* binding */ useInputId; },
/* harmony export */   "U1": function() { return /* binding */ useInputState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__);



var useInputId = function(id) {
    var backupId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
    return id || backupId;
}, useInputName = function(name) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref1;
        _tamagui_core__WEBPACK_IMPORTED_MODULE_1__.isWeb && name && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref.current, HTMLElement) && ((ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.setAttribute("name", name));
    }, [
        name
    ]), ref;
}, useFrameFocus = function(ref) {
    var focusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    return {
        inputRef: (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.useComposedRefs)(ref, focusRef),
        handleFramePress: function() {
            var _$ref;
            (_$ref = focusRef.current) === null || _$ref === void 0 ? void 0 : _$ref.focus();
        }
    };
}, useInputState = function(param) {
    var disabled = param.disabled, errorText = param.errorText, invalid = param.invalid, onFocus = param.onFocus, onBlur = param.onBlur;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), focused = ref[0], setFocused = ref[1], handleFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        setFocused(!0), onFocus && onFocus(e);
    }, [
        onFocus
    ]), handleBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        setFocused(!1), onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    return {
        state: disabled ? "inactive" : errorText || invalid ? "error" : focused ? "focused" : void 0,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        setFocused: setFocused
    };
};



/***/ }),

/***/ 45822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ TrackableContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60368);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46523);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var TrackableContainer = function(_param) {
    var analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, eventName = _param.eventName, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "trackImpression",
        "eventName"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), Component = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref
    }, props));
    return analyticsName && trackImpression ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_helpers_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ComponentWithViewTracking */ .o, {
        Component: Component,
        analyticsName: analyticsName,
        eventName: eventName,
        ref: ref
    }) : Component;
};



/***/ }),

/***/ 56350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ isKeyOfObject; }
/* harmony export */ });
function isKeyOfObject(key, obj) {
    return !!key && key in obj;
}



/***/ }),

/***/ 70357:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ useCheckbox; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/compose-refs/dist/esm/compose-refs.mjs
var compose_refs = __webpack_require__(94030);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(75425);
// EXTERNAL MODULE: ./node_modules/@tamagui/helpers/dist/esm/index.mjs + 5 modules
var dist_esm = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@tamagui/label/dist/esm/Label.mjs + 2 modules
var Label = __webpack_require__(65910);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-previous/dist/esm/index.mjs
var use_previous_dist_esm = __webpack_require__(82375);
;// CONCATENATED MODULE: ./node_modules/@tamagui/checkbox-headless/dist/esm/utils.mjs
function isIndeterminate(checked) {
  return checked === "indeterminate";
}
function getState(checked) {
  return isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}

//# sourceMappingURL=utils.mjs.map

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/checkbox-headless/dist/esm/BubbleInput.mjs




const BubbleInput = props => {
  const {
      checked,
      bubbles = !0,
      control,
      isHidden,
      ...inputProps
    } = props,
    ref = react.useRef(null),
    prevChecked = (0,use_previous_dist_esm/* usePrevious */.D)(checked);
  return react.useEffect(() => {
    const input = ref.current,
      inputProto = window.HTMLInputElement.prototype,
      setChecked = Object.getOwnPropertyDescriptor(inputProto, "checked").set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", {
        bubbles
      });
      input.indeterminate = isIndeterminate(checked), setChecked.call(input, isIndeterminate(checked) ? !1 : checked), input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]), /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
    type: "checkbox",
    defaultChecked: isIndeterminate(checked) ? !1 : checked,
    ...inputProps,
    tabIndex: -1,
    ref,
    "aria-hidden": isHidden,
    style: {
      ...(isHidden ? {
        // ...controlSize,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      } : {
        appearance: "auto",
        accentColor: "var(--color6)"
      }),
      ...props.style
    }
  });
};

//# sourceMappingURL=BubbleInput.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/checkbox-headless/dist/esm/useCheckbox.mjs








function useCheckbox(props, [checked, setChecked], ref) {
  const {
      labelledBy: ariaLabelledby,
      name,
      required,
      disabled,
      value = "on",
      onCheckedChange,
      ...checkboxProps
    } = props,
    [button, setButton] = react.useState(null),
    composedRefs = (0,compose_refs/* useComposedRefs */.ex)(ref, node => setButton(node)),
    hasConsumerStoppedPropagationRef = react.useRef(!1),
    isFormControl = esm/* isWeb */.$L ? button ? !!button.closest("form") : !0 : !1,
    labelId = (0,Label/* useLabelContext */.t0)(button),
    labelledBy = ariaLabelledby || labelId;
  return {
    bubbleInput: esm/* isWeb */.$L && isFormControl ? /* @__PURE__ */(0,jsx_runtime.jsx)(BubbleInput, {
      isHidden: !0,
      control: button,
      bubbles: !hasConsumerStoppedPropagationRef.current,
      name,
      value,
      checked,
      required,
      disabled
    }) : null,
    checkboxRef: composedRefs,
    checkboxProps: {
      role: "checkbox",
      "aria-labelledby": labelledBy,
      "aria-checked": isIndeterminate(checked) ? "mixed" : checked,
      ...checkboxProps,
      ...(esm/* isWeb */.$L && {
        type: "button",
        value,
        "data-state": getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled,
        onKeyDown: (0,dist_esm/* composeEventHandlers */.Mj)(props.onKeyDown, event => {
          event.key === "Enter" && event.preventDefault();
        })
      }),
      onPress: (0,dist_esm/* composeEventHandlers */.Mj)(props.onPress, event => {
        setChecked(prevChecked => isIndeterminate(prevChecked) ? !0 : !prevChecked), isFormControl && "isPropagationStopped" in event && (hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(), hasConsumerStoppedPropagationRef.current || event.stopPropagation());
      })
    }
  };
}

//# sourceMappingURL=useCheckbox.mjs.map


/***/ })

}]);